import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Confirmation",
    size: "xs",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        task: _ctx.task,
        label: "Delete",
        color: "negative",
        onClick: _ctx.deleteUser
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, [
        _createTextVNode(" Are you sure you want to delete "),
        _createElementVNode("strong", null, _toDisplayString(_ctx.name), 1),
        _createTextVNode("? ")
      ])
    ]),
    _: 1
  }, 512))
}